if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.boundNavClick = this.handleNavClick.bind(this);
      }

      hide() {
        super.hide();
        if (this.openedBy && typeof this.openedBy.blur === 'function') this.openedBy.blur();
        this.querySelectorAll('.product-media-modal__nav').forEach((btn) => btn.removeEventListener('click', this.boundNavClick));
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.querySelectorAll('.product-media-modal__nav').forEach((btn) => btn.addEventListener('click', this.boundNavClick));
      }

      handleNavClick(e) {
        const btn = e.currentTarget;
        const direction = btn.dataset.direction;
        const container = this.querySelector('[role="document"]');
        const items = Array.from(container.querySelectorAll('[data-media-id]'));
        const activeIndex = items.findIndex((el) => el.classList.contains('active'));
        if (activeIndex === -1) return;
        const nextIndex = direction === 'next'
          ? (activeIndex + 1) % items.length
          : (activeIndex - 1 + items.length) % items.length;
        const next = items[nextIndex];
        if (!next) return;
        items.forEach((el) => el.classList.remove('active'));
        next.classList.add('active');
        container.scrollTo({ left: next.offsetLeft - (container.clientWidth / 2) + (next.offsetWidth / 2), behavior: 'smooth' });
        if (next.nodeName === 'DEFERRED-MEDIA' && next.querySelector('template')) next.loadContent?.();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        if (!activeMedia) return;
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        if (container) {
          const scrollLeft = activeMedia.offsetLeft - (container.clientWidth / 2) + (activeMedia.offsetWidth / 2);
          container.scrollLeft = Math.max(0, scrollLeft);
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
